import React from "react";
import {_hideModal, _showError, _showModal, _showSpinner, _hideSpinner} from "../store/system/service";
import {_saveQuote, _getPolicy, _getSaveForLaterToken} from "../store/policy/service";
import FormTextField from "../ui/components/form-controls/form-text-field";
import SaveButton from '../assets/SaveButton.svg'
import EmailOutline from '../assets/EmailOutline.svg'
import axios from 'axios';

export const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};

export const checkValidity = (value, rules) => {
    let isValid = true;
    if (!rules) {
        return true;
    }

    if (rules.required) {
        isValid = value.trim() !== '' && isValid;
    }

    if (rules.minLength) {
        isValid = value.length >= rules.minLength && isValid
    }

    if (rules.maxLength) {
        isValid = value.length <= rules.maxLength && isValid
    }

    if (rules.isEmail) {
        const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        isValid = pattern.test(value) && isValid
    }

    if (rules.isNumeric) {
        const pattern = /^\d+$/;
        isValid = pattern.test(value) && isValid
    }

    return isValid;
}

export function _saveForLater({location, site}, fromHeader = "true") {
    let email = '';
    let errorMessage = '';

    const validateEmail = () => {
        if (!checkValidity(email, {required: true})) {
            errorMessage = 'Email is required';
        } else if (!checkValidity(email, {isEmail: true})) {
            errorMessage = 'Email is invalid';
        } else {
            errorMessage = '';
        }
        if (!errorMessage || errorMessage == undefined || errorMessage == null) {
            return true;
        }
        return false;
    };

    const generateContent = (errMsg) => {
        return (
            <div id="emailDiv" style={{marginTop: '20px'}}>
                <FormTextField label="Email Address" errorMessage={errMsg}
                               onChange={(event) => email = event.target.value}/>
            </div>
        );
    };

    const gaPushSaveForLater = () => {
        let saveForLaterEvent = {
            event: 'vpageview'
        };

        if (location.pathname.indexOf('/quote/summary') != -1){
            saveForLaterEvent = {
                ...saveForLaterEvent,
                pageStep: 'quote-summary-saveforlater',
                vPath: '/quotesummarysaveforlater'
            }
        } else if (location.pathname.indexOf('/application/uen') != -1) {
            saveForLaterEvent = fromHeader == 'false' ? {
                ...saveForLaterEvent,
                pageStep: 'apply-no-uen-saveforlater',
                vPath: '/applynouensaveforlater'
            } : {
                ...saveForLaterEvent,
                pageStep: 'apply-uen-saveforlater',
                vPath: '/applyuensaveforlater'
            };
        }
        _gaPushData(saveForLaterEvent);
    };

    return (dispatch, getState) => {
        let content = generateContent(errorMessage);
        let data = {
            icon: SaveButton,
            title: 'Save the quote to your email and resume at any time',
            content: content
        };
        gaPushSaveForLater();
        _showModal({
            ...data,
            primaryAction: {
                label: 'Save',
                onClick: () => {
                    _gaPushEvent('saveforlater');
                    let currState = getState();
                    if (validateEmail()) {
                        let saveForLaterObj = {
                            page: location.pathname,
                            email: email,
                            site: site,
                            policy: JSON.stringify(_getPolicy(currState)),
                            savedForLaterToken: _getSaveForLaterToken(currState)
                        };
                        _showSpinner()(dispatch, getState);
                        _saveQuote(saveForLaterObj)(dispatch, getState).then(() => {
                            _gaPushData({
                                event: 'vpageview',
                                pageStep: 'quote-saveforlater-sent',
                                vPath: '/quote-saveforlater-sent'
                            })
                            _hideSpinner()(dispatch, getState);
                            _showModal({
                                icon: EmailOutline,
                                title: (
                                    <div>
                                        <div>A link for resuming your quotation has been sent to {email}</div>
                                        <div style={{fontFamily: 'Inter-Regular', fontSize: '16px',
                                            lineHeight: '22px', textAlign: 'center',
                                            fontWeight: 'normal', marginTop: '15px'
                                        }}>
                                            If you do not receive the saved quote within 10 minutes, please check your junk/spam folder.</div>
                                    </div>
                                ),
                                primaryAction: {
                                    label: 'Continue',
                                    onClick: () => {
                                        _gaPushEvent('SavedQuoteContinue');
                                        _hideModal()(dispatch, getState);
                                    }
                                }
                            })(dispatch, getState);
                        }, (err) => {
                            _hideSpinner()(dispatch, getState);
                            _showError([err?.response?.data?.message])(dispatch, getState);
                        });
                    }
                    let modalState = currState?.sys?.modal;
                    _showModal({
                        ...modalState,
                        content: generateContent(errorMessage)
                    })(dispatch, getState);
                }
            },
            secondaryAction: {
                label: 'Cancel',
                onClick: () => {
                    _gaPushEvent('cancelsaveforlater');
                    _hideModal()(dispatch, getState);
                }
            }
        })(dispatch, getState);
    };
}

export function _formatAmount(amount, locale, prefix){
    let value = _removeFormatting(amount);

    if(_isNotDecimalChar(value)){
        return "";
    } 

    let _prefix = !prefix || prefix == "currency.prefix" ? "$" : prefix;

    return (_prefix || "") + Intl.NumberFormat(locale || "en", {  
        maximumFractionDigits: 2,
        minimumFractionDigits: 0
    }).format(value);
}

export function _removeFormatting(value){
    if(!!value){
        return "".concat(value).replace(/[^0-9.]/g, "");
    } else {
        return "";
    }
}

export function _isNotDecimalChar(value){
    if(!value || isNaN(value)){
        return true;
    } else {
        return false;
    }
}

let scrollTimer = null;
export function _scrollToComponent(ref) {
    const isIE = /*@cc_on!@*/false || !!document.documentMode;
    
    // prevent multiple call to scroll.
    if(!scrollTimer){
        scrollTimer = setTimeout(function(){
            if(isIE){
                window.scrollTo(0, ref?.current?.offsetTop);
            } else {
                window.scrollTo({top: ref?.current?.offsetTop, behavior: 'smooth'});
            }
            scrollTimer = null;
        }, 500);
    }
}

export function _scrollToComponentAbs(ref){
    const isIE = /*@cc_on!@*/false || !!document.documentMode;
    const offsetTop = window.innerWidth>768?114:120
    // prevent multiple call to scroll.
    if(!scrollTimer){
        scrollTimer = setTimeout(function(){
            if(isIE){
                window.scrollTo(0, window.pageYOffset + ref?.current?.getBoundingClientRect().top-offsetTop);
            } else {
                window.scrollTo({top: window.scrollY + ref?.current?.getBoundingClientRect().top-offsetTop, behavior: 'smooth'});
            }
            scrollTimer = null;
        }, 500);
    }
}

export function _initYum(yup) {
    if(!yup.address){
        yup.addMethod(yup.string, 'address', function(messages){
            return this.test('validate-address', messages, function(value){
                const { path, createError } = this;
                let error = "";
                
                if (value != null && value !="") {
                    if (value.match(/\s+,/g)) {
                    error = messages['space-before-comma'] || "A space before comma is not allowed";
                    } else if (value.match(/,\S/)) {
                      error = messages['space-after-comma'] || "Comma should be followed by single space";
                    } else if (value.match(/\s{2,}/)) {
                      error = messages['consecutive-spaces'] || "Two or more consecutive spaces is not allowed";
                    } else if (!value.match(/\S{2,}/)) {
                      error = messages['two-consecutive-non-space'] || "Make sure there are atleast two consecutive non-space character";
                    } else if (value.match(/^\s/)) {
                      error = messages['space-first-character'] || "Space as a first character is not allowed";
                    } else if (value.match(/(.)\1\1\1/)) {
                      error = messages['more-than-three-identical'] || "Make sure there are not more than three identical characters together";
                    } else if (value.match(/-\s/)) {
                      error = messages['space-after-hyphen'] || "Make sure hyphen is not next to blank";
                    } else if (value.match(/'\s/)) {
                      error = messages['space-after-aphostrophe'] || "Make sure apostrophe is not next to blank";
                    }
                }
    
                if(error){
                    return createError({path, message: error});
                } else {
                    return true;
                }
            });
        });
    }
}

export function _gaPushEvent(event) {
    console.log('ga_event', event);
    window.dataLayer = window.dataLayer || [];
    try {
        window.dataLayer.push({'event': event});
    } catch(ex) {
        console.error('Error in GA push data: ', ex);
    }
}

export function _gaPushData(data) {
    console.log('ga_push', data);
    window.dataLayer = window.dataLayer || [];
    try{
        window.dataLayer.push(data);
    } catch (ex) {
        console.error('Error in GA push event: ', ex);
    }
}

export async function _sendLog(message, type) {
    return new Promise(function(resolve, reject) {
        if(process.env.REACT_APP_SEND_LOG && message){
            let data = ''
            if(Array.isArray(message)){
                data = message.join(', ')
            } else {
                data = message;
            }
            const server = (process.env.REACT_APP_ENV  === 'dev' ? process.env.REACT_APP_LOCAL_URL : '');
            axios.post(server + process.env.REACT_APP_SEND_LOG + (!type ? 'error' : type), {'data': data})
                .then(resp => {
                    resolve(resp.data);
                })
                .catch(error => {
                    resolve();
                });
        }
    })
}

export const _getOccupationDesc = (code) => {
    if (code == '511035') {
        return 'Groceries Store';
    } else if (code == '511010') {
        return 'Retail Shop';
    } else if (code == '785405') {
        return 'Office';
    }
}

export function isNonProdEnvironment()  {
    const hostname = window.location.hostname;
        if (hostname.includes("dev") || hostname.includes("sys") || hostname.includes("uat2") || hostname.includes("uat1") || hostname.includes("localhost")) {
        return true;
    } else {
        return false;
    }
}

